module.exports = "/_next/static/images/arrow_right-345b726ea44aeeb671a3395710dc0d8e.svg";